import React from 'react';

import { ButtonContainer, Body } from './IntakeFormNotAvailableModal.styled';
import { Button } from 'components/v2/Buttons/Button/Button';
import { Modal } from 'components/v2/Modal/Modal';

interface Props {
  visible: boolean;
  onDismiss: Function;
}

export const IntakeFormNotAvailableModal = ({ visible, onDismiss }: Props) => {
  return (
    <Modal open={visible} onCancel={() => onDismiss()} title="Notice">
      <Body>Your form has already been submitted!</Body>
      <ButtonContainer>
        <Button label={'OK'} category="primary-dark" size="md" onClick={() => onDismiss()} />
      </ButtonContainer>
    </Modal>
  );
};
